import React, { useContext } from "react";
import CustomButton from "../components/CustomButton";
import ModalContext from "../Contexts/openModal";

const CustomerSideCta = ({
  logo,
  heading,
  buttonText,
  buttonLink,
  description,
}) => {
  const { toggleModal } = useContext(ModalContext);
  return (
    <section className="p-4 flex flex-col gap-3 bg-white rounded-[10px] border border-gray-1400">
      <div className="flex flex-col pb-3 gap-2 border-b border-b-gray-1400">
        {logo && (
          <img src={logo} loading="eager" alt="Logo" className="max-w-36" />
        )}
        {description && (
          <p className="text-gray-2500 font-inter text-base font-normal tracking-tight_1">
            {description}
          </p>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-purple-1100 font-manrope text-2xl leading-7 tracking-tightest_5 font-semibold">
          {heading}
        </p>
        <CustomButton
          onClick={toggleModal}
          target="_blank"
          text={buttonText}
          buttonClass={`bg-purple-1500 text-white hover:bg-[#5E24FF]`}
        />
      </div>
    </section>
  );
};

export default CustomerSideCta;
